import { useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { track } from "../lib/track";
import { SERVICES } from "../data/services";

export function ContactForm({ sourcePage = "contact", defaultService = "" }) {
  const [form, setForm] = useState({ name: "", email: "", company: "", phone: "", service_interest: defaultService, message: "" });
  const [state, setState] = useState({ loading: false, done: false, error: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, done: false, error: "" });
    try {
      await api.post("/leads", { ...form, source_page: sourcePage });
      track("contact_submit", window.location.pathname, sourcePage);
      setState({ loading: false, done: true, error: "" });
    } catch (err) {
      setState({ loading: false, done: false, error: errorMessage(err) });
    }
  };

  if (state.done) {
    return (
      <div data-testid="contact-success" className="card flex items-start gap-4 border-emerald-200 bg-emerald-50/60">
        <CheckCircle2 className="mt-0.5 text-emerald-600" />
        <div>
          <div className="font-semibold text-[var(--navy)]">Thank you — your enquiry has been received.</div>
          <p className="mt-1 text-sm text-slate-600">A member of our HEOR team will respond within one business day.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="contact-form" className="grid gap-4 sm:grid-cols-2">
      <div><label className="label">Full name *</label><input data-testid="contact-name" required className="input" value={form.name} onChange={set("name")} placeholder="Dr. Jane Doe" /></div>
      <div><label className="label">Work email *</label><input data-testid="contact-email" required type="email" className="input" value={form.email} onChange={set("email")} placeholder="jane@company.com" /></div>
      <div><label className="label">Organisation</label><input data-testid="contact-company" className="input" value={form.company} onChange={set("company")} placeholder="Company / Institution" /></div>
      <div><label className="label">Phone</label><input data-testid="contact-phone" className="input" value={form.phone} onChange={set("phone")} placeholder="+91 …" /></div>
      <div className="sm:col-span-2">
        <label className="label">Area of interest</label>
        <select data-testid="contact-service" className="input" value={form.service_interest} onChange={set("service_interest")}>
          <option value="">Select a service</option>
          {SERVICES.map((s) => <option key={s.slug} value={s.name}>{s.name}</option>)}
          <option value="Other">Other</option>
        </select>
      </div>
      <div className="sm:col-span-2"><label className="label">How can we help? *</label><textarea data-testid="contact-message" required rows={5} className="input" value={form.message} onChange={set("message")} placeholder="Tell us about your evidence needs, timelines and target markets." /></div>
      {state.error && <div data-testid="contact-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 sm:col-span-2">{state.error}</div>}
      <div className="sm:col-span-2">
        <button data-testid="contact-submit" disabled={state.loading} className="btn-primary disabled:opacity-60"><Send size={15} /> {state.loading ? "Sending…" : "Send enquiry"}</button>
      </div>
    </form>
  );
}
